/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import cx from 'classnames';

import './styles.sass';

const SearchForm = ({ withSearchClear, defaultQuery }) => {
  const [query, setQuery] = useState(defaultQuery);
  const [submittedQuery, setSubmittedQuery] = useState(defaultQuery);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmittedQuery(query);
    navigate('/search', { state: { query } });
  };

  const handleSearchClear = () => {
    setQuery('');
    setSubmittedQuery('');
    navigate('/search', { state: { query: '' } });
  };

  return (
    <section className="block block__search-form">
      <form onSubmit={handleSubmit}>
        <label className="visuallyHidden" id="searchLabel" htmlFor="search">
          Search resources
        </label>
        <input
          className="search-form__input"
          id="search"
          type="text"
          name="s"
          value={query}
          placeholder="Search"
          onChange={(e) => setQuery(e.target.value)}
        />
        <input
          className="search-form__submit"
          type="submit"
          value="Submit search"
        />
        {withSearchClear && (
          <button
            className={cx('search-form__button', 'text-link', {
              'search-form__button--hidden': !submittedQuery,
            })}
            onClick={handleSearchClear}
            type="button"
          >
            Clear Search
          </button>
        )}
      </form>
    </section>
  );
};

SearchForm.propTypes = {
  withSearchClear: PropTypes.bool,
  defaultQuery: PropTypes.string,
};

SearchForm.defaultProps = {
  withSearchClear: false,
  defaultQuery: '',
};

export default SearchForm;
